import { render, staticRenderFns } from "./goodsSpecificationDialog.vue?vue&type=template&id=9f0d1036"
import script from "./goodsSpecificationDialog.vue?vue&type=script&lang=js"
export * from "./goodsSpecificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports